import { writable } from 'svelte/store';

export interface PreviewContent {
  title: string;
  excerptHtml: string;
  infoboxHtml?: string;
  previewImage?: { src: string; alt: string; orientation: 'wide' | 'tall' };
  path: string;
}

export interface PreviewStackItem {
  preview: PreviewContent | null;
  linkRect: DOMRect;
  parentRect: DOMRect | null;
}

export const previewStack = writable<PreviewStackItem[]>([]);
